import React from 'react'

import ActualSize from '../../images/icons/actual-size.svg'
import AI from '../../images/icons/ai.svg'
import Anchor from '../../images/icons/anchor.svg'
import ArrowLong from '../../images/icons/arrow-long.svg'
import Archive from '../../images/icons/archive.svg'
import Badge from '../../images/icons/badge.svg'
import BadImage from '../../images/icons/bad-image.svg'
import Bag from '../../images/icons/bag.svg'
import Ban from '../../images/icons/ban.svg'
import BarChart from '../../images/icons/bar-chart.svg'
import BarCodeNo from '../../images/icons/bar-code-no.svg'
import BarCode from '../../images/icons/bar-code.svg'
import BasketLoaded from '../../images/icons/basket-loaded.svg'
import Basket from '../../images/icons/basket.svg'
import Bell from '../../images/icons/bell.svg'
import BellSnooze from '../../images/icons/bell-snooze.svg'
import Beta from '../../images/icons/beta.svg'
import Briefcase from '../../images/icons/briefcase.svg'
import Bubble from '../../images/icons/bubble.svg'
import Bubbles from '../../images/icons/bubbles.svg'
import Bulb from '../../images/icons/bulb.svg'
import Calculator from '../../images/icons/calculator.svg'
import Calendar from '../../images/icons/calendar.svg'
import CallIn from '../../images/icons/call-in.svg'
import CallOut from '../../images/icons/call-out.svg'
import Call from '../../images/icons/call.svg'
import Carat from '../../images/icons/carat.svg'
import CaretUp from '../../images/icons/caret-up.svg'
import CaretDown from '../../images/icons/caret-down.svg'
import CaretLeft from '../../images/icons/caret-left.svg'
import CaretRight from '../../images/icons/caret-right.svg'
import Caution from '../../images/icons/caution.svg'
import CheckNoCircle from '../../images/icons/check-no-circle.svg'
import Check from '../../images/icons/check.svg'
import Chemestry from '../../images/icons/chemestry.svg'
import Clipboard from '../../images/icons/clipboards.svg'
import Clock from '../../images/icons/clock.svg'
import ClockDollar from '../../images/icons/clock-dollar.svg'
import Close from '../../images/icons/close.svg'
import Compass from '../../images/icons/compass.svg'
import Config from '../../images/icons/config.svg'
import Controller from '../../images/icons/controller.svg'
import CreditCard from '../../images/icons/credit-card.svg'
import Crop from '../../images/icons/crop.svg'
import CSV from '../../images/icons/csv.svg'
import Cup from '../../images/icons/cup.svg'
import Cursor from '../../images/icons/cursor.svg'
import Diamond from '../../images/icons/diamond.svg'
import Damaged from '../../images/icons/damaged.svg'
import Dash from '../../images/icons/dash.svg'
import DatabaseOff from '../../images/icons/database-off.svg'
import Direction from '../../images/icons/direction.svg'
import Directions from '../../images/icons/directions.svg'
import Disc from '../../images/icons/disc.svg'
import Dislike from '../../images/icons/dislike.svg'
import Document from '../../images/icons/document.svg'
import Documents from '../../images/icons/documents.svg'
import DollarExclamation from '../../images/icons/dollar-exclamation.svg'
import DownCaret from '../../images/icons/down-caret.svg'
import Download from '../../images/icons/download.svg'
import DragHandle from '../../images/icons/drag-handle.svg'
import Drawer from '../../images/icons/drawer.svg'
import Dribbble from '../../images/icons/dribbble.svg'
import Dropbox from '../../images/icons/dropbox.svg'
import Droplet from '../../images/icons/droplet.svg'
import DotsVertical from '../../images/icons/dots-vertical.svg'
import EmoticonHappy from '../../images/icons/emoticon-happy.svg'
import EmoticonSad from '../../images/icons/emoticon-sad.svg'
import End from '../../images/icons/end.svg'
import Energy from '../../images/icons/energy.svg'
import EnvelopeLetter from '../../images/icons/envelope-letter.svg'
import EnvelopeOpen from '../../images/icons/envelope-open.svg'
import Envelope from '../../images/icons/envelope.svg'
import ErrorWarning from '../../images/icons/error.svg'
import Eye from '../../images/icons/eye.svg'
import EyeglassesNo from '../../images/icons/eyeglasses-no.svg'
import Eyeglasses from '../../images/icons/eyeglasses.svg'
import Facebook from '../../images/icons/facebook.svg'
import Feed from '../../images/icons/feed.svg'
import FemaleUser from '../../images/icons/female-user.svg'
import Female from '../../images/icons/female.svg'
import Figma from '../../images/icons/figma.svg'
import Film from '../../images/icons/film.svg'
import Filter from '../../images/icons/filter.svg'
import FileDownload from '../../images/icons/file-download.svg'
import FileSearch from '../../images/icons/file-search.svg'
import FileTextSpark from '../../images/icons/file-text-spark.svg'
import FileUpload from '../../images/icons/file-upload.svg'
import Fire from '../../images/icons/fire.svg'
import Flag from '../../images/icons/flag.svg'
import Folder from '../../images/icons/folder.svg'
import FolderOff from '../../images/icons/folder-off.svg'
import FolderX from '../../images/icons/folder-x.svg'
import Follow from '../../images/icons/follow.svg'
import Following from '../../images/icons/following.svg'
import Forward from '../../images/icons/forward.svg'
import Frame from '../../images/icons/frame.svg'
import Friends from '../../images/icons/friends.svg'
import FullScreen from '../../images/icons/full-screen.svg'
import Ghost from '../../images/icons/ghost.svg'
import Globe1 from '../../images/icons/globe-1.svg'
import Globe2 from '../../images/icons/globe-2.svg'
import GraduationCap from '../../images/icons/graduation-cap.svg'
import Graph from '../../images/icons/graph.svg'
import GridIcon from '../../images/icons/grid.svg'
import Hamburger from '../../images/icons/hamburger.svg'
import Handbag from '../../images/icons/handbag.svg'
import HeadphonesMicrophone from '../../images/icons/headphones-microphone.svg'
import Headphones from '../../images/icons/headphones.svg'
import Heart from '../../images/icons/heart.svg'
import HeartExclamation from '../../images/icons/heart-exclamation.svg'
import Help from '../../images/icons/help.svg'
import Home from '../../images/icons/home.svg'
import Hourglass from '../../images/icons/hourglass.svg'
import Info from '../../images/icons/info.svg'
import InfoDocument from '../../images/icons/info-document.svg'
import Vat from '../../images/icons/vat.svg'
import JumpBack from '../../images/icons/jump-back.svg'
import JumpFwd from '../../images/icons/jump-fwd.svg'
import Key from '../../images/icons/key.svg'
import L from '../../images/icons/l.svg'
import Language from '../../images/icons/language.svg'
import Launch from '../../images/icons/launch.svg'
import Layers from '../../images/icons/layers.svg'
import Left from '../../images/icons/left.svg'
import Like from '../../images/icons/like.svg'
import Link from '../../images/icons/link.svg'
import List from '../../images/icons/list.svg'
import Lock from '../../images/icons/lock.svg'
import Login from '../../images/icons/login.svg'
import Logout from '../../images/icons/logout.svg'
import Loop from '../../images/icons/loop.svg'
import Loyalty from '../../images/icons/loyalty.svg'
import MagicWand from '../../images/icons/magic-wand.svg'
import Magnet from '../../images/icons/magnet.svg'
import Magnifier from '../../images/icons/magnifier.svg'
import MaleUser from '../../images/icons/male-user.svg'
import Male from '../../images/icons/male.svg'
import Map from '../../images/icons/map.svg'
import Microphone from '../../images/icons/microphone.svg'
import Minus from '../../images/icons/minus.svg'
import Monitor from '../../images/icons/monitor.svg'
import Mouse from '../../images/icons/mouse.svg'
import Moustache from '../../images/icons/moustache.svg'
import Move from '../../images/icons/move.svg'
import MusicNote1 from '../../images/icons/music-note1.svg'
import MusicNote2 from '../../images/icons/music-note2.svg'
import New from '../../images/icons/new.svg'
import NoImage from '../../images/icons/no-img.svg'
import Note from '../../images/icons/note.svg'
import Notebook from '../../images/icons/notebook.svg'
import OpenedBook from '../../images/icons/opened-book.svg'
import Options from '../../images/icons/options.svg'
import PackageExport from '../../images/icons/package-export.svg'
import PalletFull from '../../images/icons/pallet-full.svg'
import Pallet from '../../images/icons/pallet.svg'
import PaperClip from '../../images/icons/paper-clip.svg'
import PaperPlane from '../../images/icons/paper-plane.svg'
import PatternPlus from '../../images/icons/pattern-plus.svg'
import Pattern from '../../images/icons/pattern.svg'
import Pause from '../../images/icons/pause.svg'
import Pencil from '../../images/icons/pencil.svg'
import Phone from '../../images/icons/phone.svg'
import Photo from '../../images/icons/photo.svg'
import Picture from '../../images/icons/picture.svg'
import PieChart from '../../images/icons/pie-chart.svg'
import Pin from '../../images/icons/pin.svg'
import Plane from '../../images/icons/plane.svg'
import Play from '../../images/icons/play.svg'
import Playlist from '../../images/icons/playlist.svg'
import Plus from '../../images/icons/plus.svg'
import Pointer from '../../images/icons/pointer.svg'
import PopoverTriangle from '../../images/icons/popover_arrow.svg'
import Power from '../../images/icons/power.svg'
import Present from '../../images/icons/present.svg'
import PresentationOff from '../../images/icons/presentation-off.svg'
import Printer from '../../images/icons/printer.svg'
import Products from '../../images/icons/products.svg'
import PuzzleSolid from '../../images/icons/puzzle-solid.svg'
import Puzzle from '../../images/icons/puzzle.svg'
import Question from '../../images/icons/question.svg'
import Refresh from '../../images/icons/refresh.svg'
import Reload from '../../images/icons/reload.svg'
import ReportSearch from '../../images/icons/report-search.svg'
import Required from '../../images/icons/required.svg'
import ReviewDocument from '../../images/icons/review-document.svg'
import Rewind from '../../images/icons/rewind.svg'
import Right from '../../images/icons/right.svg'
import Rocket from '../../images/icons/rocket.svg'
import ReceiptRefund from '../../images/icons/receipt-refund.svg'
import ReceiptDollar from '../../images/icons/receipt-dollar.svg'
import Save from '../../images/icons/save.svg'
import Scanner from '../../images/icons/scanner.svg'
import SellThrough from '../../images/icons/sell-through.svg'
import Sellers from '../../images/icons/sellers.svg'
import SelectAll from '../../images/icons/select-all-icon.svg'
import Settings from '../../images/icons/settings.svg'
import Share1 from '../../images/icons/share1.svg'
import Share2 from '../../images/icons/share2.svg'
import Shield from '../../images/icons/shield.svg'
import Shuffle from '../../images/icons/shuffle.svg'
import Speach from '../../images/icons/speach.svg'
import Speedometer from '../../images/icons/speedometer.svg'
import StarHalfSolid from '../../images/icons/half_star.svg'
import StarSolid from '../../images/icons/full_star.svg'
import Star from '../../images/icons/star.svg'
import Start from '../../images/icons/start.svg'
import Stop from '../../images/icons/stop.svg'
import Storybook from '../../images/icons/storybook.svg'
import Tablet from '../../images/icons/tablet.svg'
import Tag from '../../images/icons/tag.svg'
import Target from '../../images/icons/target.svg'
import Threepn from '../../images/icons/threepn.svg'
import Toggle from '../../images/icons/toggle.svg'
import Tools from '../../images/icons/tools.svg'
import TrafficCone from '../../images/icons/traffic-cone.svg'
import Traffic from '../../images/icons/traffic.svg'
import Trash from '../../images/icons/trash.svg'
import TrendDown from '../../images/icons/trend-down.svg'
import TrendEven from '../../images/icons/trend-even.svg'
import TrendUp from '../../images/icons/trend-up.svg'
import Truck from '../../images/icons/truck.svg'
import Tumblr from '../../images/icons/tumblr.svg'
import Twitter from '../../images/icons/twitter.svg'
import Umbrella from '../../images/icons/umbrella.svg'
import Unfollow from '../../images/icons/unfollow.svg'
import Unlock from '../../images/icons/unlock.svg'
import Upload from '../../images/icons/upload.svg'
import Users from '../../images/icons/users.svg'
import Van from '../../images/icons/van.svg'
import Vector from '../../images/icons/vector.svg'
import Video from '../../images/icons/video.svg'
import Voice from '../../images/icons/voice.svg'
import Volume1 from '../../images/icons/volume-1.svg'
import Volume2 from '../../images/icons/volume-2.svg'
import VolumeOff from '../../images/icons/volume-off.svg'
import Wallet from '../../images/icons/wallet.svg'
import Wrench from '../../images/icons/wrench.svg'
import X from '../../images/icons/x.svg'
import XLSX from '../../images/icons/xls.svg'
import Youtube from '../../images/icons/youtube.svg'
import ZoomIn from '../../images/icons/zoom-in.svg'
import ZoomOut from '../../images/icons/zoom-out.svg'

const iconsList = {
  actualSize: <ActualSize />,
  ai: <AI />,
  anchor: <Anchor />,
  arrowLong: <ArrowLong />,
  archive: <Archive />,
  badge: <Badge />,
  bag: <Bag />,
  ban: <Ban />,
  barCode: <BarCode />,
  barCodeNo: <BarCodeNo />,
  barChart: <BarChart />,
  basketLoaded: <BasketLoaded />,
  basket: <Basket />,
  bell: <Bell />,
  bellSnooze: <BellSnooze />,
  beta: <Beta />,
  briefcase: <Briefcase />,
  bubble: <Bubble />,
  bubbles: <Bubbles />,
  bulb: <Bulb />,
  calculator: <Calculator />,
  calendar: <Calendar />,
  callIn: <CallIn />,
  callOut: <CallOut />,
  call: <Call />,
  carat: <Carat />,
  caretUp: <CaretUp />,
  caretDown: <CaretDown />,
  caretLeft: <CaretLeft />,
  caretRight: <CaretRight />,
  caution: <Caution />,
  checkNoCircle: <CheckNoCircle />,
  check: <Check />,
  chemestry: <Chemestry />,
  clipboard: <Clipboard />,
  clock: <Clock />,
  clockDollar: <ClockDollar />,
  close: <Close />,
  compass: <Compass />,
  config: <Config />,
  controller: <Controller />,
  creditCard: <CreditCard />,
  crop: <Crop />,
  cup: <Cup />,
  cursor: <Cursor />,
  csv: <CSV />,
  damaged: <Damaged />,
  dash: <Dash />,
  databaseOff: <DatabaseOff />,
  diamond: <Diamond />,
  direction: <Direction />,
  directions: <Directions />,
  disc: <Disc />,
  dislike: <Dislike />,
  document: <Document />,
  documents: <Documents />,
  dollarExclamation: <DollarExclamation />,
  downCaret: <DownCaret />,
  download: <Download />,
  dragHandle: <DragHandle />,
  drawer: <Drawer />,
  dribbble: <Dribbble />,
  dropbox: <Dropbox />,
  droplet: <Droplet />,
  dotsVertical: <DotsVertical />,
  emoticonHappy: <EmoticonHappy />,
  emoticonSad: <EmoticonSad />,
  end: <End />,
  energy: <Energy />,
  envelopeLetter: <EnvelopeLetter />,
  envelopeOpen: <EnvelopeOpen />,
  envelope: <Envelope />,
  errorWarning: <ErrorWarning />,
  eye: <Eye />,
  eyeglassesNo: <EyeglassesNo />,
  eyeglasses: <Eyeglasses />,
  facebook: <Facebook />,
  feed: <Feed />,
  femaleUser: <FemaleUser />,
  female: <Female />,
  figma: <Figma />,
  film: <Film />,
  filter: <Filter />,
  fileDownload: <FileDownload />,
  fileSearch: <FileSearch />,
  fileTextSpark: <FileTextSpark />,
  fileUpload: <FileUpload />,
  fire: <Fire />,
  flag: <Flag />,
  folder: <Folder />,
  folderOff: <FolderOff />,
  folderX: <FolderX />,
  follow: <Follow />,
  following: <Following />,
  forward: <Forward />,
  frame: <Frame />,
  friends: <Friends />,
  fullScreen: <FullScreen />,
  ghost: <Ghost />,
  globe1: <Globe1 />,
  globe2: <Globe2 />,
  graduationCap: <GraduationCap />,
  graph: <Graph />,
  gridIcon: <GridIcon />,
  hamburger: <Hamburger />,
  handbag: <Handbag />,
  headphonesMicrophone: <HeadphonesMicrophone />,
  headphones: <Headphones />,
  heart: <Heart />,
  heartExclamation: <HeartExclamation />,
  help: <Help />,
  home: <Home />,
  hourglass: <Hourglass />,
  info: <Info />,
  infoDocument: <InfoDocument />,
  vat: <Vat />,
  jumpBack: <JumpBack />,
  jumpFwd: <JumpFwd />,
  key: <Key />,
  l: <L />,
  language: <Language />,
  launch: <Launch />,
  layers: <Layers />,
  left: <Left />,
  like: <Like />,
  link: <Link />,
  list: <List />,
  lock: <Lock />,
  login: <Login />,
  logout: <Logout />,
  loop: <Loop />,
  loyalty: <Loyalty />,
  magicWand: <MagicWand />,
  magnet: <Magnet />,
  magnifier: <Magnifier />,
  maleUser: <MaleUser />,
  male: <Male />,
  map: <Map />,
  microphone: <Microphone />,
  minus: <Minus />,
  monitor: <Monitor />,
  mouse: <Mouse />,
  moustache: <Moustache />,
  move: <Move />,
  musicNote1: <MusicNote1 />,
  musicNote2: <MusicNote2 />,
  new: <New />,
  noImage: <NoImage />,
  note: <Note />,
  notebook: <Notebook />,
  openedBook: <OpenedBook />,
  options: <Options />,
  packageExport: <PackageExport />,
  pallet: <Pallet />,
  palletFull: <PalletFull />,
  paperClip: <PaperClip />,
  paperPlane: <PaperPlane />,
  pattern: <Pattern />,
  patternPlus: <PatternPlus />,
  pause: <Pause />,
  pencil: <Pencil />,
  phone: <Phone />,
  photo: <Photo />,
  picture: <Picture />,
  badImage: <BadImage />,
  pieChart: <PieChart />,
  pin: <Pin />,
  plane: <Plane />,
  play: <Play />,
  playlist: <Playlist />,
  plus: <Plus />,
  pointer: <Pointer />,
  popoverTriangle: <PopoverTriangle />,
  power: <Power />,
  present: <Present />,
  presentationOff: <PresentationOff />,
  printer: <Printer />,
  products: <Products />,
  puzzle: <Puzzle />,
  puzzleSolid: <PuzzleSolid />,
  question: <Question />,
  refresh: <Refresh />,
  reload: <Reload />,
  reportSearch: <ReportSearch />,
  required: <Required />,
  reviewDocument: <ReviewDocument />,
  rewind: <Rewind />,
  right: <Right />,
  rocket: <Rocket />,
  receiptRefund: <ReceiptRefund />,
  receiptDollar: <ReceiptDollar />,
  save: <Save />,
  scanner: <Scanner />,
  sellThrough: <SellThrough />,
  sellers: <Sellers />,
  settings: <Settings />,
  selectall: <SelectAll />,
  share1: <Share1 />,
  share2: <Share2 />,
  shield: <Shield />,
  shuffle: <Shuffle />,
  speach: <Speach />,
  speedometer: <Speedometer />,
  star: <Star />,
  starSolid: <StarSolid />,
  starHalfSolid: <StarHalfSolid />,
  start: <Start />,
  stop: <Stop />,
  storybook: <Storybook />,
  tablet: <Tablet />,
  tagLabel: <Tag />,
  target: <Target />,
  threepn: <Threepn />,
  toggle: <Toggle />,
  tools: <Tools />,
  traffic: <Traffic />,
  trafficCone: <TrafficCone />,
  trash: <Trash />,
  trendDown: <TrendDown />,
  trendEven: <TrendEven />,
  trendUp: <TrendUp />,
  truck: <Truck />,
  tumblr: <Tumblr />,
  twitter: <Twitter />,
  umbrella: <Umbrella />,
  unfollow: <Unfollow />,
  unlock: <Unlock />,
  upload: <Upload />,
  users: <Users />,
  van: <Van />,
  vector: <Vector />,
  video: <Video />,
  voice: <Voice />,
  volume1: <Volume1 />,
  volume2: <Volume2 />,
  volumeOff: <VolumeOff />,
  wallet: <Wallet />,
  wrench: <Wrench />,
  x: <X />,
  xlsx: <XLSX />,
  youtube: <Youtube />,
  zoomIn: <ZoomIn />,
  zoomOut: <ZoomOut />,
}

export default iconsList
